var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmlid2268(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.8751 4.42546V27.5574C25.8751 28.0195 25.4229 28.4303 24.8245 28.4303H3.15219C2.55378 28.4303 2.10156 28.0195 2.10156 27.5574V0.997881C2.10156 0.535786 2.55378 0.125 3.15219 0.125H20.8003L25.8751 4.42546Z",
    fill: "white",
    stroke: "#262629",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.963 28.4303C24.255 28.2272 24.4467 27.9163 24.4467 27.5574V4.36754V4.30968L24.4026 4.27224L19.5167 0.125H20.8086L25.875 4.42539V27.5574C25.875 28.0195 25.4228 28.4303 24.8244 28.4303H23.963Z",
    fill: "#E5E5E5",
    stroke: "#262629",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9707 0.269772L25.6588 4.24254H22.0213C21.4229 4.24254 20.9707 3.83175 20.9707 3.36966V0.269772Z",
    fill: "white",
    stroke: "#262629",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.033 13.397H7.07895C6.65945 13.397 6.35205 13.1092 6.35205 12.7989C6.35205 12.4887 6.65945 12.2008 7.07895 12.2008H21.033C21.4525 12.2008 21.7599 12.4887 21.7599 12.7989C21.7599 13.1164 21.4611 13.397 21.033 13.397Z",
    fill: "white",
    stroke: "#262629",
    strokeWidth: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.033 17.1066H7.07895C6.65945 17.1066 6.35205 16.8187 6.35205 16.5085C6.35205 16.1983 6.65945 15.9104 7.07895 15.9104H21.033C21.4525 15.9104 21.7599 16.1983 21.7599 16.5085C21.7599 16.826 21.4611 17.1066 21.033 17.1066Z",
    fill: "white",
    stroke: "#262629",
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.033 20.8161H7.07895C6.65945 20.8161 6.35205 20.5282 6.35205 20.218C6.35205 19.9077 6.65945 19.6199 7.07895 19.6199H21.033C21.4525 19.6199 21.7599 19.9077 21.7599 20.218C21.7599 20.5355 21.4611 20.8161 21.033 20.8161Z",
    fill: "white",
    stroke: "#262629",
    strokeWidth: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7988 9.63695H0.125V5.70535C0.125 5.48815 0.339806 5.27356 0.655957 5.27356H11.7988C12.1087 5.27356 12.3297 5.48283 12.3297 5.70535V9.20516C12.3297 9.42236 12.1149 9.63695 11.7988 9.63695Z",
    fill: "#F55B4B",
    stroke: "#262629",
    strokeWidth: 0.25
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.98688 9.26508H12.3243C12.2892 9.46015 12.0857 9.63695 11.7988 9.63695H0.125V5.70535C0.125 5.48815 0.339806 5.27356 0.655957 5.27356H0.863199V6.59476C0.863199 8.08483 2.27639 9.26508 3.98688 9.26508Z",
    fill: "#DD4E43",
    stroke: "#262629",
    strokeWidth: 0.25
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8514 9.88684V11.3763L0.309339 9.88684H1.8514Z",
    fill: "#DB1B1B",
    stroke: "#262629",
    strokeWidth: 0.25
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19502 8.33008V8.81456H1.41455V8.33008H1.84902V6.42833H1.41455V5.94385H3.19502C3.61245 5.94385 3.92765 6.02339 4.15766 6.1897C4.38768 6.35602 4.49842 6.58018 4.49842 6.85496C4.49842 7.01404 4.45583 7.15866 4.37915 7.28882C4.30248 7.41898 4.20026 7.52021 4.07247 7.58529C3.94469 7.6576 3.80838 7.70099 3.64652 7.72991C3.48466 7.75883 3.28873 7.76606 3.0502 7.76606H2.72648V8.32285H3.19502V8.33008ZM2.72648 7.28882H2.85426C3.15242 7.28882 3.34836 7.24543 3.43355 7.16589C3.51874 7.08635 3.56133 6.97788 3.56133 6.85496C3.56133 6.75372 3.52726 6.65972 3.46762 6.58741C3.40799 6.5151 3.33984 6.47171 3.26317 6.45002C3.1865 6.43556 3.05871 6.4211 2.87982 6.4211H2.71795V7.28882H2.72648Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M4.70312 8.81444V8.32996H5.21426V6.4282H4.70312V5.94373H6.3047C6.64546 5.94373 6.90954 5.95819 7.12252 5.99434C7.32697 6.0305 7.52291 6.11004 7.71033 6.22573C7.89775 6.34866 8.05109 6.50775 8.16183 6.71021C8.27258 6.91268 8.33221 7.13684 8.33221 7.3827C8.33221 7.58517 8.28962 7.77317 8.21295 7.95395C8.13627 8.13473 8.03405 8.27934 7.91478 8.39504C7.79552 8.50351 7.65921 8.59751 7.48883 8.66259C7.32697 8.72767 7.17363 8.77105 7.03733 8.79275C6.90102 8.81444 6.68805 8.82167 6.3984 8.82167H4.70312V8.81444ZM6.10024 8.32996H6.31321C6.56878 8.32996 6.77324 8.30104 6.92658 8.24319C7.07992 8.18534 7.19919 8.08411 7.28438 7.94672C7.37809 7.8021 7.42068 7.62132 7.42068 7.38993C7.42068 7.173 7.37809 6.98499 7.28438 6.83314C7.19067 6.68129 7.0714 6.57282 6.90954 6.51498C6.7562 6.45713 6.55175 6.4282 6.31321 6.4282H6.10024V8.32996Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72412 8.81444V8.32996H9.2097V6.4282H8.72412V5.94373H11.7569V6.83314H11.1094V6.43544H10.0957V7.10069H10.8283V7.58517H10.0957V8.32996H10.6153V8.81444H8.72412Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5038 10.9818H2.10986V9.88684H11.7163V9.97787C11.7085 10.5137 11.1865 10.9818 10.5038 10.9818Z",
    fill: "#E5E5E5",
    stroke: "#262629",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmlid2268);
export default __webpack_public_path__ + "static/media/XMLID_2268_.4eed8569e1b053fa3038a8540998d1ec.svg";
export { ForwardRef as ReactComponent };